var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoRemoveBadWords = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 32,
  fill: "none",
  viewBox: "0 0 36 32",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35.093,
  height: 28,
  fill: "#D42E2E",
  rx: 5
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m14.217 13.829 1.172-1.167c.554.307 1.665 1.87 2.181 2.087.49-.213 1.528-1.635 2.171-2.073.25.173 1.096 1.003 1.17 1.222-.463.52-1.79 1.67-2.046 2.095.135.317.755.861 1.014 1.121.222.224.931.875 1.035 1.115l-1.172 1.138c-.606-.419-1.669-1.84-2.171-2.056-.478.22-1.581 1.625-2.171 2.054l-1.185-1.134c.274-.546 1.873-1.727 2.055-2.238-.186-.345-.731-.793-1.034-1.092l-.91-.907c-.026-.034-.094-.153-.106-.165zM8.824 26c.289-.104 3.175-2.428 3.648-2.796.38-.297 1.25-.18 2.015-.18 3.484 0 7.268.054 10.72.003.73-.012 1.098-.284 1.108-1.022l-.003-10.832c0-2.458.29-2.142-4.26-2.142-1.988 0-12.293-.131-12.798.134-.554.29-.447.98-.447 1.659v10.828c0 1.374-.08 3.005.016 4.348z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.024 9h17.045v13H9.024z"
})))));
export { SvgLogoRemoveBadWords as ReactComponent };
export default __webpack_public_path__ + "assets/images/logo-remove-bad-words.svg";